import getInvertedMultiplier from "./getInvertedMultiplier";
export default function getDistanceForDirection(layout, gestureDirection) {
    var multiplier = getInvertedMultiplier(gestureDirection);
    switch(gestureDirection){
        case "vertical":
        case "vertical-inverted":
            return layout.height * multiplier;
        case "horizontal":
        case "horizontal-inverted":
            return layout.width * multiplier;
    }
}
